export const ROUTES = {
  AUTH: {
    LOGIN: 'auth/login',
    LOGOUT: 'auth/logout',
    RESET_PASSWORD: 'password-reset',
    RESET_PASSWORD_CONFIRM: 'password-reset/confirm',
  },
}
